module.exports = __webpack_public_path__ + "static/media/gameplay4-en.1875ab7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/gameplay4-en.png
// module id = 196
// module chunks = 0